import { Button } from '@app/components/various/Button';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDatePickerSelectionContext, useDatePickerSettingsContext } from '../context';

import { DatePickerClearButton } from './DatePickerClearButton';

interface Props {
  shouldShowClear: boolean;
  shouldShowToday: boolean;
}

export const DatePickerFooter = ({ shouldShowClear, shouldShowToday }: Props) => {
  const { t } = useTranslation(['dates']);
  const { isDateView, shouldDisable } = useDatePickerSettingsContext();
  const { handleSelect } = useDatePickerSelectionContext();

  const selectToday = React.useCallback(() => {
    handleSelect(dayjs());
  }, [handleSelect]);

  const isTodayButtonDisabled = React.useMemo(() => shouldDisable(dayjs()), [shouldDisable]);

  if (!isDateView || (!shouldShowClear && !shouldShowToday)) {
    return null;
  }

  return (
    <div className="mt-2 flex justify-between border-t border-t-neutral-90 pt-2">
      {shouldShowToday && (
        <Button color="secondary" variant="ghost" disabled={isTodayButtonDisabled} onClick={selectToday}>
          {t('dates:today')}
        </Button>
      )}
      {shouldShowClear && <DatePickerClearButton />}
    </div>
  );
};
